import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { Button } from 'components/atoms/button'

interface TicketPriceUpdatedModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm?: () => void
}

export function TicketPriceUpdatedModal({ open, setOpen, onConfirm }: TicketPriceUpdatedModalProps) {
	const handleConfirm = () => {
		setOpen(false)
		onConfirm?.()
	}

	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			className="z-50"
			hideCloseButton={true}
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[304px] text-center">
					<div>
						<h3 className="text-2xl font-bold flex justify-center items-center gap-2">
							Ticket Price Updated
						</h3>
					</div>
					<div className="mt-5 text-lg">
						The price for your queued ticket has changed. Please review and complete your purchase.
					</div>
				</div>
				<Button variant="primary" fullWidth onClick={handleConfirm}>
					OK
				</Button>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface TicketPriceUpdatedModalManagedProps {
	onConfirm?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'ticket-price-updated': TicketPriceUpdatedModalManagedProps
	}
}

export function ManagedTicketPriceUpdatedModal({
	onClose,
	onConfirm,
}: TicketPriceUpdatedModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<TicketPriceUpdatedModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm?.(); handleClose() }}
		/>
	)
}
